/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];

    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    let txBuf = feature.getSettingValue('TXBUF');
    const sockets = feature.getSettingValue('SOCKETS');
    const capabilities = PlatformUtils.getCapabilities(feature.project);
    if (capabilities.includes('tios_g1')) {
        txBuf = '1';
    }

    blocks.push({
        location: 'services_start',
        blockType: BlockType.CODE,
        template: `
http_server_start()`,
    });

    blocks.push({
        location: 'on_sock_data_arrival',
        blockType: BlockType.CODE,
        template: `
http_server_proc_sock_data()`,
    });

    blocks.push({
        location: 'on_sock_event',
        blockType: BlockType.CODE,
        template: `
http_server_proc_sock_event(newstate,newstatesimple)`,
    });

    blocks.push({
        location: 'on_sock_data_sent',
        blockType: BlockType.CODE,
        template: `
http_server_proc_sock_data_sent()`,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
http_server_proc_timer()`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
sub callback_http_server_header_received(byref server as http_server_state, byref header as string, byref value as string)
    '****callback_http_server_header_received****'
end sub

sub callback_http_server_body_received(byref server as http_server_state, byref body as string)
    '****callback_http_server_body_received****'
end sub

function callback_http_server_endpoint_called(byref server as http_server_state) as boolean
    callback_http_server_endpoint_called=false
    '****callback_http_server_endpoint_called****'
end function
`,
    });

    const ENDPOINTS = feature.getSettingValue('ENDPOINTS');
    for (let i = 0; i < ENDPOINTS.length; i++) {
        blocks = blocks.concat(ENDPOINTS[i].getCodeBlocks());
    }

    return blocks;
};
